import { useState, useCallback } from 'react';
import dayjs from 'dayjs';
import { FuelConsumptionService } from '../services/fuelConsumptionService';
import type {
    FuelConsumptionRecord,
    FuelConsumptionSummary,
    FuelConsumptionFilters,
} from '../types';

export const useFuelConsumption = () => {
    const [records, setRecords] = useState<FuelConsumptionRecord[]>([]);
    const [summary, setSummary] = useState<FuelConsumptionSummary | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [filters, setFilters] = useState<FuelConsumptionFilters>({
        // Lacak's refuel events and activity are complete only after the nightly sync.
        date: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
    });

    const fetchData = useCallback(async (newFilters?: FuelConsumptionFilters) => {
        setLoading(true);
        setError(null);

        try {
            const appliedFilters = newFilters ?? filters;
            const response = await FuelConsumptionService.getVsLacak(appliedFilters);

            if (response.status === 'success') {
                setRecords(response.data || []);
                setSummary(response.summary ?? null);
                setFilters(appliedFilters);
            } else {
                throw new Error('Failed to fetch data');
            }
        } catch (err: any) {
            const errorMessage =
                err.response?.data?.detail || err.response?.data?.message || err.message || 'Gagal mengambil data';
            setError(errorMessage);
            setRecords([]);
            setSummary(null);
        } finally {
            setLoading(false);
        }
    }, [filters]);

    return {
        records,
        summary,
        loading,
        error,
        filters,
        fetchData,
    };
};
